import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
export const useOrderStore = defineStore('orderStore', () => {
    const deliveryPrice = computed(() => {
        var _a;
        if (!((_a = deliveryService.value) === null || _a === void 0 ? void 0 : _a.price) || (deliveryService.value.free && orderSum.value >= deliveryService.value.free)) {
            return 0;
        }
        return deliveryService.value.price;
    });
    const orderSum = ref(0);
    const paymentSystems = ref([]);
    const paymentSystem = ref(0);
    const bonusAmount = ref(0);
    const usedBonuses = ref();
    const city = ref('');
    const delivery = ref();
    const deliveryService = ref();
    const totalSum = computed(() => orderSum.value + deliveryPrice.value);
    const citySelected = computed(() => city.value && city.value.length >= 4);
    const currentPaymentSystem = computed(() => paymentSystems.value.find(system => system.id === paymentSystem.value));
    const sumToPay = computed(() => totalSum.value - (usedBonuses.value || 0));
    function setOrderSum(sum) {
        orderSum.value = sum;
    }
    function setCity(newCity) {
        city.value = newCity;
    }
    function setDeliveryService(newDelivery) {
        delivery.value = newDelivery ? newDelivery.id : null;
        deliveryService.value = newDelivery;
    }
    return {
        // delivery
        delivery, deliveryService, deliveryPrice, setDeliveryService,
        // payment systems
        paymentSystems, paymentSystem, currentPaymentSystem,
        // city
        city, citySelected, setCity,
        // bonuses
        bonusAmount, usedBonuses,
        // totals
        orderSum, totalSum, sumToPay, setOrderSum,
    };
});
